// Images
import bunTop from "../../assets/images/ingredients/bun_top.svg";
import bunBottom from "../../assets/images/ingredients/bun_bottom.svg";
import cheeseUncooked from "../../assets/images/ingredients/cheese_uncooked.svg";
import lettuce from "../../assets/images/ingredients/lettuce.svg";
import pattyUncooked from "../../assets/images/ingredients/patty_uncooked.svg";
import pattyCooked from "../../assets/images/ingredients/patty_cooked.svg";
import pattyOvercooked from "../../assets/images/ingredients/patty_overcooked.svg";
import {
  get,
  template,
  intersectionWith,
  differenceWith,
  xorWith,
  isEqual,
} from "lodash";
import moment from "moment";
import { burgerType, IngreditentPointMap } from "../../constants/ingredients";
import { useDrop } from "react-dnd";
import {
  setPoints,
  updateBurgerTray,
  increaseMoves,
  shiftBurgerOrder,
  shiftBurgerQueue,
  setCorrectServed,
  updateCorrectIngredientsPlaced,
  updateTotalIngredientsPlaced,
  updateBurgerQueueWhenDropped,
} from "../../store/ingredient";
// styles
import "./styles.scss";
import { useDispatch, useSelector } from "react-redux";

const BurgerOnDisplay = (props) => {
  const burgerMap = (ingredient) => {
    switch (ingredient) {
      case "patty":
        return pattyCooked;
      case "buntop":
        return bunTop;
      case "cheese":
        return cheeseUncooked;
      case "lettuce":
        return lettuce;
      case "bunbottom":
        return bunBottom;
    }
  };

  const burgerTray = useSelector((state) =>
    get(state, "ingredients.burgerTray", [])
  );
  const dispatch = useDispatch();

  const checkTheBurger = (item, burger) => {
    dispatch(increaseMoves());
    const originalBurgerIngredients = burgerType[burger].ingredients;
    const burgerIngredients = burgerTray[item.index].ingredients;
    if (burgerIngredients.length >= 3) {
      const pattyTypeArray = [];
      let pattyArray = [];
      let points = 0;
      pattyArray = burgerIngredients.map((item, index) => {
        if (
          item === "pattyCooked" ||
          item === "pattyUnCooked" ||
          item === "pattyOverCooked"
        ) {
          pattyTypeArray.push(item);
          return "patty";
        } else {
          return item;
        }
      });

      if (isEqual(originalBurgerIngredients, pattyArray)) {
        dispatch(setCorrectServed());
        dispatch(
          updateCorrectIngredientsPlaced({
            correctIngredients: originalBurgerIngredients.length,
          })
        );
        dispatch(
          updateTotalIngredientsPlaced({
            totalIngredients: originalBurgerIngredients.length,
          })
        );
      } else {
        dispatch(
          updateTotalIngredientsPlaced({
            totalIngredients: originalBurgerIngredients.length,
          })
        );
      }
      var intersectionArray = differenceWith(
        originalBurgerIngredients,
        xorWith(originalBurgerIngredients, pattyArray, isEqual),
        isEqual
      );
      intersectionArray.map((item, index) => {
        if (item === "patty") {
          if (pattyTypeArray.length !== 0) {
            points = points + IngreditentPointMap[pattyTypeArray.pop()];
          }
        } else {
          points = points + IngreditentPointMap[item];
        }
      });
      //check the timings of the burger
      const timeDiffrence = moment().diff(
        moment(props.expectedEndTime),
        "seconds"
      );
      if (timeDiffrence >= 10 && points !== 0) {
        points = 1;
      }
      if (timeDiffrence >= 5 && timeDiffrence < 10) {
        points = Math.ceil(points / 4);
      }
      if (timeDiffrence >= 1 && timeDiffrence < 5) {
        points = Math.ceil(points / 2);
      }

      dispatch(setPoints(points));
      dispatch(
        updateBurgerTray({
          index: item.index,
          value: {
            ...burgerTray[item.index],
            ingredients: [],
            discountPoint: points,
          },
        })
      );
      // dispatch(shiftBurgerQueue());
      dispatch(
        updateBurgerQueueWhenDropped({
          dropPointIndex: props.index || 0,
        })
      );
    }
  };
  const [{ isOver }, drop] = useDrop({
    accept: "burger",
    drop: (item, monitor) => checkTheBurger(item, props.burger),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  return (
    <div className="burgerOnDisplay-root" ref={drop}>
      <div className="burger-container row">
        {
          burgerType[props.burger].ingredients
            .map((item, index) => (
              <div
                className="burger-element col-12"
                style={{ zIndex: (index + 1) * 100 }}
              >
                <img src={burgerMap(item)} alt="" srcset="" />
              </div>
            ))
            .reverse()
          // makeBurger()
        }
      </div>
    </div>
  );
};

export default BurgerOnDisplay;
